<bb-tile class="main-graph"
	[headerBar]="true"
	[loading]="loadingViewData"
	[noData]="!loadingViewData && !haveGraphData"
>
	<span class="tile-title">
		{{ viewers | number }} {{ 'VIEWERS' | translate | lowercase}} <bb-info [contents]="'HELP.PROJECT_STATS_VIEWERS' | translate"></bb-info>
	</span>
	<bb-chart
		[type]="'line'"
		[datasets]="viewersGraphDatasets"
		height="250"
		styling="analytics"
		[bbChartSettings]="{
			maxTicksLimitY: 10,
			xAxisLabels: xAxisLabels,
			maxLabelRotation: 0
		}"
	></bb-chart>
</bb-tile>
<div class="metrics" *ngIf="project?.kpiCalculations?.length > 0">
	<h3 class="kpi-metrics-header">
		{{ 'KPI_METRICS' | translate }}
	</h3>
	<bb-kpi-performance [project]="project" [isLoading]="loadingPerformanceData" [configuration]="configuration"></bb-kpi-performance>
	<bb-tile class="metrics"
		[headerBar]="true"
		[loading]="loadingPerformanceData"
		[noData]="!havePerformanceData && !loadingPerformanceData"
	>
		<span class="tile-title">
			{{ selectedKPI?.label }} <bb-info *ngIf="selectedKPI?.description" [contents]="selectedKPI.description"></bb-info>
		</span>
		<bb-chart
			styling="analytics"
			[type]="'bar'"
			[bbChartSettings]="{
				maxTicksLimitY: 7,
				maxLabelRotation: 0,
				scaleYSuggestedMax: performanceDataYMax,
				showLegend: false,
				tooltipTitleColor: '#3E3E3E',
				tooltipFirstItem: tooltipFirstItem,
				tooltipLastItem: tooltipLastItem
			}"
			[pluginOptions]="pluginOptions"
			[datasets]="kpiGraphDatasets"
			height="250"
		></bb-chart>
	</bb-tile>
</div>
